import { useState } from "react";
import { classNames } from "../../helpers";

const TextInput = (props) => {
  const [touched, setTouched] = useState(false);
  const {
    id,
    name,
    label,
    type,
    value,
    onChange,
    required,
    placeholder,
    invalidMsg,
  } = props;

  return (
    <label className="block mb-4">
      {label && (
        <span className="block text-base font-medium text-gray-700">
          {label}
          {required && <span>*</span>}
        </span>
      )}

      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        onBlur={() => {
          setTouched(true);
        }}
        className={classNames(
          "w-full mt-2 block px-3 py-2 bg-white border border-slate-300 rounded-md focus:outline-none",
          "focus:ring-1 focus:ring-artfulRed focus:border-artfulRed-550 focus:z-10 hover:border-artfulRed-550",
          "disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none",
          " focus:invalid:border-red-500 focus:invalid:ring-red-500",
          "transition-all duration-300 ease-in-out peer",
          touched ? "invalid:border-red-500 invalid:text-red-600" : ""
        )}
        placeholder={placeholder}
      />
      {touched && invalidMsg && (
        <p className="mt-1 invisible peer-invalid:visible text-red-600 text-sm">
          {invalidMsg}
        </p>
      )}
    </label>
  );
};

TextInput.defaultProps = {
  type: "text",
  required: false,
};

export default TextInput;
